import React, { useState } from "react" 
import { cn } from "lib/utils"


export default function Sortable({ 
  item,
  activated, 
  onDragStart,
  onDragOver,
  onDragEnd,
  onDrop,
  className="",
  children 
}:any){

  const [ dragging, setDragging ] = useState(false)

  const handleDragStart = (e:any) => {
    if( onDragStart ) {
      setDragging(true)
      onDragStart(e)
    }
  }

  const handleDragEnd = (e:any) => {
    if( onDragEnd ) {
      setDragging(false)
      onDragEnd(e)
    }
  }

  const handleDragOver = (e:any) => {
    e.preventDefault()
    if( onDragOver ) {
      onDragOver(e)
    }
  }

  const handleDrop = (e:any) => {
    e.preventDefault()
    if( onDrop ) {
      onDrop(e)
    }
  }

  return (
    <div 
      data-refstr={item.refstr}
      draggable={activated}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragEnd={handleDragEnd}  
      onDrop={handleDrop}
      className={cn(
        "ring-offset-2",
        dragging ? "ring-offset-teal-800" : "ring-offset-transparent",
      )}
    >
      { children }
    </div>
  )
}